import { render, staticRenderFns } from "./totalSchoolList.vue?vue&type=template&id=925e4e32&scoped=true&"
import script from "./totalSchoolList.vue?vue&type=script&lang=js&"
export * from "./totalSchoolList.vue?vue&type=script&lang=js&"
import style0 from "./totalSchoolList.vue?vue&type=style&index=0&id=925e4e32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925e4e32",
  null
  
)

export default component.exports